import { Select } from "@mantine/core";
import { useState } from "react";
import { useEffect } from "react";
import { withTranslation } from "react-i18next";

import InputField from "../../components/inputField";
import { backendUrl } from "../../constants";
import "./styles.css";

const AccountInfo = ({ acountInfo, setAccountInfo }) => {
  let user = JSON.parse(localStorage.getItem("userData"));
  const [timezone, setTimezone] = useState([]);
  const [states, setStates] = useState([]);

  //timezone
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/timezone`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setTimezone((tz) => [...tz, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  //states
  useEffect(() => {
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}lookup/getLookupByType/state`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = { value: obj._id, label: obj.lookupName };
          setStates((st) => [...st, a]);
        });
      })
      .catch((err) => console.error(err));
  }, []);

  return (
    <div className="d-flex flex-column gap-2 px-5">
      <h5 className="text-dark text-center">General Information</h5>
      <InputField
        placeholder="Email Address"
        disabled={true}
        width="100%"
        value={acountInfo.email}
        style={{ height: "40px" }}
      />
      <InputField
        placeholder="First Name"
        width="100%"
        value={acountInfo.firstName}
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setAccountInfo((acc) => ({ ...acc, firstName: v.target.value }))
        }
      />
      <InputField
        placeholder="Last Name"
        width="100%"
        value={acountInfo.lastName}
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setAccountInfo((acc) => ({ ...acc, lastName: v.target.value }))
        }
      />
      <InputField
        placeholder="Physical Address"
        width="100%"
        value={acountInfo.physicalAddress}
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setAccountInfo((acc) => ({ ...acc, physicalAddress: v.target.value }))
        }
      />
      <InputField
        placeholder="City"
        width="100%"
        value={acountInfo.city}
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setAccountInfo((acc) => ({ ...acc, city: v.target.value }))
        }
      />
      <Select
        placeholder="State"
        data={states}
        // searchable
        maxDropdownHeight={400}
        value={acountInfo.state}
        onChange={(v) => setAccountInfo((acc) => ({ ...acc, state: v }))}
      />
      <InputField
        placeholder="Zip"
        width="100%"
        value={acountInfo.zipCode}
        style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
        onChange={(v) =>
          setAccountInfo((acc) => ({ ...acc, zipCode: v.target.value }))
        }
      />
      <Select
        placeholder="Time Zone"
        data={timezone}
        // searchable
        maxDropdownHeight={400}
        value={acountInfo.timeZone}
        onChange={(v) => setAccountInfo((acc) => ({ ...acc, timeZone: v }))}
      />
      {user.role !== "JobSeeker" && (
        <InputField
          placeholder="EIN Number"
          width="100%"
          style={{ border: "1px solid rgb(0,0,0,0.2)", height: "40px" }}
          value={acountInfo.EIN}
          onChange={(v) =>
            setAccountInfo((acc) => ({ ...acc, EIN: v.target.value }))
          }
        />
      )}
    </div>
  );
};
export default withTranslation()(AccountInfo);
